import React from 'react'
import { Drawer, Button, Input, Icon } from 'antd'
import CommentInput from '../../CommentInput'
import EntitySelectorList from '../../EntitySelectorList'

const SettingsDrawer = ({
  visible,
  selectedSettings,
  formData,
  onClose,
  updateSettings,
  saveSettings
}) => {
  return (
    <Drawer
      title="Shot Editor"
      placement="right"
      closable={true}
      onClose={onClose}
      visible={visible}
      width={400}
    >
      {selectedSettings && (
        <div className="settings-drawer-content">
          <CommentInput
            text={selectedSettings.initial_image_prompt}
            placeholder="Write your image prompt..."
            characters={formData.characterList}
            onChange={value => updateSettings('initial_image_prompt', value)}
          />

          {/* <EntitySelectorList
            activePrompt={
              selectedSettings.initial_image_prompt &&
              selectedSettings.initial_image_prompt.length < 1000
                ? selectedSettings.initial_image_prompt
                : ''
            }
            formData={formData}
            disabled={false}
          /> */}
          <div className="setting-group">
            <label>Voiceover Text</label>
            <Input.TextArea
              rows={4}
              value={selectedSettings.voiceover_text}
              onChange={e => updateSettings('voiceover_text', e.target.value)}
              placeholder="Write your voiceover text..."
            />
          </div>
          <div className="setting-group">
            <label>Lighting</label>
            <Input.TextArea
              rows={4}
              value={selectedSettings.lighting}
              onChange={e => updateSettings('lighting', e.target.value)}
              placeholder="Write your lighting text..."
            />
          </div>
          <div className="setting-group">
            <label>Scenery</label>
            <Input.TextArea
              rows={4}
              value={selectedSettings.scenery}
              onChange={e => updateSettings('scenery', e.target.value)}
              placeholder="Write your scenery text..."
            />
          </div>

          <Button
            type="primary"
            onClick={saveSettings}
            style={{ marginTop: 16, width: '100%' }}
          >
            Apply Changes
          </Button>
        </div>
      )}
    </Drawer>
  )
}

export default SettingsDrawer
